import { Check, Mail } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { copyText } from '@/lib/clipboard'

const COPIED_FOR_MS = 2000

/**
 * The vault's intake address, as a mail-client link that also copies itself —
 * a `mailto:` does nothing at all on a machine with no handler registered for it.
 */
export function IntakeEmailButton({ intakeEmail }: { intakeEmail: string }) {
  const [copied, setCopied] = useState(false)

  async function copy() {
    try {
      await copyText(intakeEmail)
      setCopied(true)
      setTimeout(() => setCopied(false), COPIED_FOR_MS)
      toast.success(`${intakeEmail} copied to your clipboard`)
    } catch {
      toast.error("We couldn't copy the address. Try again.")
    }
  }

  return (
    <Button
      size="sm"
      href={`mailto:${intakeEmail}?subject=${encodeURIComponent('Compliance documents')}`}
      onClick={() => void copy()}
    >
      {copied ? <Check /> : <Mail />}
      Send via email to {intakeEmail}
    </Button>
  )
}
